"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var TextBtn_1 = __importDefault(require("./TextBtn"));
function CouponLadder(props) {
    var title = props.title, describe = props.describe, rule = props.rule, buttonText = props.buttonText, couponList = props.couponList, theme = props.theme;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var themeClass = theme ? "coupon-ladder-".concat(theme) : '';
    /**
     * 渲染卡券右侧折扣列表
     * @param item 卡券右侧list数据
     * @param index map循环的index
     */
    function renderCouponCard(item, index) {
        var top = item.top, center = item.center, bottom = item.bottom;
        return (react_1.default.createElement("div", { key: "card-".concat(index), className: "coupon-base-card" },
            react_1.default.createElement("div", { className: "card-title" }, top),
            react_1.default.createElement("div", { className: "card-content" },
                react_1.default.createElement("div", { className: "card-save" }, center),
                react_1.default.createElement("span", { className: "card-num" }, bottom))));
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "-coupon-ladder-mobile"), themeClass) },
        react_1.default.createElement("div", { className: "coupon-ladder-header" },
            react_1.default.createElement("div", { className: "header-title header-title-font" }, title),
            react_1.default.createElement("div", { className: "desc desc-font" }, describe),
            rule && react_1.default.createElement(TextBtn_1.default, __assign({ className: "header-rule-font" }, rule))),
        react_1.default.createElement("div", { className: "coupon-ladder-right" },
            couponList.map(renderCouponCard),
            react_1.default.createElement("button", { className: "coupon-ladder-button" }, buttonText))));
}
exports.default = CouponLadder;
//# sourceMappingURL=CouponLadderMobile.js.map